import React, { FC, ReactElement, useEffect, useState } from 'react';
import cns from 'classnames';
import './TextBlocks.scss';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { internalizationState } from 'src/stores/reducers/sections';
import localeFieldResolver from 'src/helpers/locale-field-finder';
import { getContentDataTextBlocks, ITextBlock, ITextBlocks } from '../../../../stores/reducers/userData';

export interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
  };
  sectionName?: string;
  sectionData?: any;
  sectionId?: string;
}

const TextBlocks: FC<Props> = ({ className, sectionId, sectionName, bgSettings, sectionData }): ReactElement => {
  const { value: textColor } = sectionData.params!.find((param: any) => param.type === 'textBlocksFontColor');
  const { checked: isVisible } = sectionData.params!.find((param: any) => param.className === 'is-textBlocks-visible');
  const textBlocks = useSelector(getContentDataTextBlocks);
  const [block, setBlock] = useState<ITextBlock>();
  const { activeLangState } = useSelector(internalizationState);

  useEffect(() => {
    if (textBlocks) {
      setBlock(textBlocks[sectionData.block as keyof ITextBlocks]);
    }
  }, [textBlocks, sectionData.block]);

  return (
    block ?
      <section className={cns('page-section', className)} style={{ backgroundColor: bgSettings?.color }} id={sectionId}>
        <div className="text-block" style={{ display: isVisible ? 'block' : 'none' }}>
          <h1 style={{ textAlign: 'center', marginBottom: '24px', color: textColor || '#000' }}>{sectionName}</h1>
            <div key={`${block}_id`} className="inner-text-block" style={{ color: textColor || '#000' }}>
              <h3 className="text-block-title">{localeFieldResolver(block, 'title', activeLangState)}</h3>
              <div className="inner-text" style={{ color: textColor || '#000' }}>
                {ReactHtmlParser(localeFieldResolver(block, 'content', activeLangState))}
              </div>
            </div>
        </div>
      </section>
    :
      <></>
  );
};

export default TextBlocks;
